var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "365.000000pt",
    height: "84.000000pt",
    viewBox: "0 0 365.000000 84.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,84.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1390 810 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 790 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 780 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357 763 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 744 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 740 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 730 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 700 c0 -13 7 -20 20 -20 13 0 20 7 20 20 0 13 -7 20 -20 20 -13 0 -20 -7 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527 714 c-4 -4 -7 -16 -7 -26 0 -13 7 -18 26 -18 21 0 25 4 22 22 -3 23 -27 35 -41 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 695 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 680 c-116 -20 -215 -106 -249 -218 -55 -176 15 -354 168 -429 51 -25 67 -28 157 -28 81 0 109 5 147 22 70 32 131 94 164 166 25 53 29 74 29 152 0 76 -4 99 -26 145 -50 107 -128 168 -243 189 -66 12 -80 12 -147 1z m218 -75 c96 -48 146 -138 146 -266 1 -63 -4 -86 -27 -133 -50 -102 -142 -156 -266 -156 -116 0 -207 56 -257 158 -24 48 -28 69 -28 137 1 151 75 250 212 285 61 15 160 4 220 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 663 c0 -15 -9 -22 -31 -27 -17 -3 -35 -3 -40 0 -5 3 -9 -4 -9 -15 0 -16 -6 -21 -25 -21 -16 0 -25 6 -25 15 0 8 -9 15 -20 15 -16 0 -20 -7 -20 -30 0 -27 -3 -30 -30 -30 l-30 0 0 -280 0 -280 65 0 65 0 0 100 0 100 123 0 c146 0 185 10 239 58 95 86 105 221 23 328 -36 48 -106 76 -202 82 -78 5 -83 4 -83 -15z m132 -113 c49 -14 78 -55 78 -112 0 -90 -48 -118 -205 -118 l-105 0 0 120 0 120 98 0 c53 0 114 -5 134 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2560 660 c-20 -20 -26 -65 -12 -86 25 -38 91 -39 117 -1 21 31 19 54 -10 82 -29 30 -68 32 -95 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 660 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 630 c0 -28 3 -30 35 -30 32 0 35 2 35 30 0 28 -3 30 -35 30 -32 0 -35 -2 -35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3413 603 l-33 -4 0 -60 0 -59 -45 0 -45 0 0 -50 0 -50 45 0 45 0 0 -125 c0 -137 9 -173 55 -215 24 -23 35 -25 115 -25 49 0 91 3 94 6 3 3 -1 27 -10 52 l-16 47 -39 -6 c-30 -5 -44 -2 -59 11 -18 16 -20 31 -20 137 l0 118 65 0 65 0 0 50 0 50 -65 0 -65 0 0 65 c0 72 5 69 -87 58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956 480 c-16 -5 -46 -23 -68 -40 l-38 -31 0 36 c0 31 -3 35 -25 35 l-25 0 2 -232 c3 -230 3 -233 25 -236 21 -3 21 0 25 155 4 175 11 203 70 244 23 17 50 24 93 27 72 4 119 -16 152 -67 22 -32 23 -44 23 -197 l0 -164 25 0 25 0 0 163 c0 137 -3 168 -19 203 -40 88 -160 135 -265 104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132 475 c-128 -40 -192 -177 -150 -319 29 -95 144 -164 258 -153 163 14 261 156 215 313 -38 133 -182 203 -323 159z m149 -111 c59 -30 83 -130 47 -197 -26 -50 -120 -72 -178 -42 -82 42 -80 196 2 241 32 18 93 17 129 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2995 481 c-38 -10 -68 -26 -84 -45 -17 -20 -31 -11 -31 20 0 23 -3 24 -55 24 l-55 0 0 -235 0 -235 60 0 60 0 0 139 c0 127 2 141 23 172 54 80 159 79 199 -1 15 -28 18 -62 18 -172 l0 -138 61 0 61 0 -4 163 c-3 134 -6 168 -22 197 -23 45 -54 78 -86 95 -33 17 -108 26 -145 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2550 245 l0 -235 60 0 60 0 0 235 0 235 -60 0 -60 0 0 -235z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogo);
export default __webpack_public_path__ + "static/media/client-logo.c42b63fb60797e47a83ad7f27d70615a.svg";
export { ForwardRef as ReactComponent };